// Та же таблица, что в datahub src/services/sales/avitoProfile.ts и feedgen app/helpers/avitoProfile.js.
const CYRILLIC: Record<string, string> = {
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'g',
    д: 'd',
    е: 'e',
    ё: 'yo',
    ж: 'zh',
    з: 'z',
    и: 'i',
    й: 'y',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'h',
    ц: 'ts',
    ч: 'ch',
    ш: 'sh',
    щ: 'sch',
    ъ: '',
    ы: 'y',
    ь: '',
    э: 'e',
    ю: 'yu',
    я: 'ya',
    і: 'i',
    ї: 'yi',
    є: 'ye',
    ґ: 'g',
}

export function profileFilenameFromName(name: string): string {
    let out = ''
    for (const ch of name.toLowerCase()) {
        if (/[a-z0-9_]/.test(ch)) {
            out += ch
        } else if (Object.prototype.hasOwnProperty.call(CYRILLIC, ch)) {
            out += CYRILLIC[ch]
        }
    }
    return out
}
